import React from 'react'
let PropTypes = React.PropTypes
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'
import api from '../../../apiClient/v1'
import { TablaInventarios } from './TablaInventarios.jsx'
import {
    ModalTrigger,
    ModalGenerarOC

} from './Modales.jsx'

export class PeticionOC extends React.Component{
    constructor(props) {
        super(props)
        this.state = {}
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
    }
    getChildContext(){
        return {
            agregarOrdenCompra: (numeroOC)=>{
                let request = api.facturacion(this.props.cliente).agregarOrdenCompra(this.props.fechaInicial, this.props.fechaFinal, numeroOC)
                request
                    .then(()=>this.refs.notificator.success("Proceso satisfactorio", "Número orden de compra agregado correctamente.", 4*1000))
                    .catch(this.ajaxErrorHandler('Agregar orden compra'));
                return request
            }
        }
    }
    render() {
    return (
        <div className={'container-fluid'}>
            <div className={'row'}>
                <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                <BotonGenerarOC
                    sumaUnidades = {this.props.sumaUnidades}
                    valorBruto = {this.props.valorBruto}
                    valorNeto = {this.props.valorNeto}
                />
                <h4>Favor pulse el botón "AGREGAR OC" para indicar orden de compra de los siguientes inventarios realizados</h4>
            </div>
            <TablaInventarios
                sumaUnidades = {this.props.sumaUnidades}
                valorNeto = {this.props.valorNeto}
                inventarios ={this.props.inventarios}
            />
        </div>       
        )
    }
}
PeticionOC.propTypes = {
    // Permisos
    //permisos: PropTypes.object.isRequired
    inventarios: PropTypes.arrayOf(PropTypes.object),
    sumaUnidades: PropTypes.string,
    valorBruto: PropTypes.string,
    valorNeto: PropTypes.string,
    cliente: PropTypes.number,
    fechaInicial: PropTypes.string,
    fechaFinal: PropTypes.string
}
PeticionOC.childContextTypes = {
    agregarOrdenCompra: PropTypes.func
}
const BotonGenerarOC = ({sumaUnidades, valorBruto, valorNeto})=>
    <ModalTrigger>
        {(isVisible, showModal, hideModal)=>
            <button className="btn btn-md btn-primary pull-right" onClick={showModal}>
                {isVisible && <ModalGenerarOC
                    sumaUnidades={sumaUnidades}
                    valorBruto={valorBruto}
                    valorNeto={valorNeto}
                    hideModal={hideModal}
                />}
                {'AGREGAR OC'}
            </button>
        }
    </ModalTrigger>



// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/peticionOC/PeticionOC.jsx